import React from 'react';
import EducationCertifications from '../components/EducationCertifications';
import Contact from '../components/Contact';
import { portfolioData } from '../mock';

const EducationPage = () => {
  return (
    <div className="pt-20">
      <EducationCertifications data={portfolioData} />
      <Contact data={portfolioData} />
    </div>
  );
};

export default EducationPage;